import type { FC } from 'react';
import ArrowIcon from '@public/assets/common/icons/arrow.svg';
import GiftIcon from '@public/assets/common/icons/bonusOpen.svg';
import FreebetIcon from '@public/assets/common/icons/freebet.svg';
import WalletIcon from '@public/assets/common/icons/wallet.svg';
import type { CouponAccountSelectItemProps, CouponSelectItemIcons } from './CouponAccountSelectItem.types';
import styles from './CouponAccountSelectItem.module.scss';
const itemIcons: CouponSelectItemIcons = {
  BONUS: GiftIcon,
  BALANCE: WalletIcon,
  FREEBET: FreebetIcon
};
const CouponAccountSelectItem: FC<CouponAccountSelectItemProps> = ({
  type,
  text,
  amount,
  active,
  disabled,
  onClick,
  className,
  classes,
  withArrow
}) => {
  const ItemIcon: SvgComponent = itemIcons[type];
  return <button type="button" className={cn(styles.root, className, {
    [styles.active]: active,
    [styles.withArrow]: withArrow
  })} onClick={onClick} disabled={disabled} data-sentry-component="CouponAccountSelectItem" data-sentry-source-file="CouponAccountSelectItem.tsx">
      {!!ItemIcon && <ItemIcon width={20} height={20} className={cn(styles.prefixIcon, classes?.prefixIcon)} />}
      {!!text && <span className={cn(styles.text, classes?.text)}>{text}</span>}
      {amount && <span className={cn(styles.amount, classes?.amount)}>{amount}</span>}
      {withArrow && <span className={styles.arrowWrapper}>
          <ArrowIcon width={10} height={6} className={cn(styles.arrow, classes?.arrow)} />
        </span>}
    </button>;
};
export { CouponAccountSelectItem };